module.exports = __webpack_public_path__ + "static/graphic-globe-ff74fa60a79e037a4ee7700f6e5b6418.svg";